__turbopack_context__.v({
  "backgroundImage": "AdvantageCard-module-scss-module__BwmN6q__backgroundImage",
  "card": "AdvantageCard-module-scss-module__BwmN6q__card",
  "subtitle": "AdvantageCard-module-scss-module__BwmN6q__subtitle",
  "text": "AdvantageCard-module-scss-module__BwmN6q__text",
  "title": "AdvantageCard-module-scss-module__BwmN6q__title",
});
